import { IconButton, Menu, MenuItem } from '@mui/material';
import { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as ProfileIcon } from '../../../assets/icons/profile-icon.svg';
import { signOut } from '../../../store/auth/auth.action';

const UserBox = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const dispatch = useDispatch();

    const handleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const doLogout = () => {
        dispatch(signOut());
        handleClose();
    };

    return (
        <Fragment>
            <IconButton onClick={handleMenu}>
                <ProfileIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={doLogout}>Logout</MenuItem>
            </Menu>
        </Fragment>
    );
};

export default UserBox;
